<template>
  <div :id="$attrs['id']"
       :style="$attrs['style']"
       :class="[$attrs['class'], gridClasses, { 'btn--inline--icon-left': iconLeft != null }, { 'btn--inline--icon-right': iconRight != null }, { 'btn--disabled': disabled }]"
       :disabled="disabled"
       class="btn--inline"
       @click="throttledOnClick($event)">
    <icon v-if="iconLeft != null" :icon="iconLeft" /><span class="btn--inline__text"><slot /></span><icon v-if="iconRight != null" :icon="iconRight" />
  </div>
</template>

<script>

import GridMixin from '@/mixins/GridMixin';
import { throttle } from 'lodash';
import TimerMixin from '../../../mixins/TimerMixin';

export default {
  name: 'HmButton',

  mixins: [GridMixin],

  props: {
    iconLeft: {
      required: false,
      default: null,
    },
    iconRight: {
      required: false,
      default: null,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    throttle: {
      type: Number,
      default: 500,
    },
  },

  data: function () {
    return {
      throttledOnClick: throttle(this.onclick, this.throttle, { leading: true, trailing: false }),
    };
  },

  computed: {

  },

  methods: {
    onclick($event) {
      if (this.disabled !== true) {
        this.$emit('click', $event);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

  .btn {
    direction: ltr;
    &--square {
      direction: ltr;
      display: grid!important;
      grid-template-columns: 1fr;
      justify-items: center;
      height: auto!important;
      padding-left: 0rem!important;
      padding-right: 0rem!important;
      padding-bottom: 2rem!important;
      padding-top: 1rem!important;

      @media(max-width: $br-mobile) {
        padding-bottom: 1.5rem!important;
        padding-top: 0.5rem!important;
      }

      .hm-icon {
        display: block;
        width: 100% !important;
        max-width: 62px;
        height: auto!important;
        margin-bottom: -5px;

        /deep/ svg * {
          stroke-width: 0.5!important;
        }
      }

      .btn--inline__text {
        // font-size: 1.5rem;
      }
    }

    &--disabled {
      cursor: not-allowed;
    }

    &--inline__text {
      display: flex;
      flex-grow: 1;
      text-align: left;
    }
  }

  .btn--inline {
    direction: ltr;
    user-select: none;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 3.2rem;
    width: 100%;
    margin-top: 0.6rem;
    margin-bottom: 2rem;

    z-index: 1;
    border-radius: 0.3rem;
    padding: 0 1rem;
    cursor: pointer;
    text-align: center;

    color: $text;
    border: 0.1rem solid $middlegray;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:hover {
      background-color: $lightmint;
      border-color: $mint;
    }

    &__text {
      display: inline-block;
    }

    &--icon-right {
      padding-right: 0!important;
    }

    &--icon-left {
      padding-left: 0!important;
    }

    &--width-auto {
      width: min-content!important;
      display: inline-flex!important;
      overflow: hidden;
      white-space: nowrap;
      margin-right: 1rem!important;
      margin-top: 0.5rem!important;
      margin-bottom: 0.5rem!important;
      margin-left: 0!important;
    }


    &.btn--disabled {
      background-color: $lightgray;
      cursor: not-allowed;
      border-color: $middlegray!important;
      color: $middlegray!important;
      @include icon-color($middlegray);

      &.btn--color {
        background-color: rgba(var(--button-color), 0.15);
      }

      &:hover {
        background-color: $lightgray;
        border-color: $middlegray!important;
        color: $middlegray!important;
      }
    }
  }
  .btn--icon-only {
    width: 3.2rem!important;
    height: 3.2rem!important;
    direction: ltr;
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    padding-left: 0rem!important;
    padding-right: 0rem!important;
    padding-bottom: 1rem!important;

    background-color: $mint;
    border-color: $mint;
    color: $white;
    // box-shadow: 0 6px 15px 0 rgba(0,39,46,0.4);
    position: relative;
    transition: background-color 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;
    border-radius: 50%;

    @include icon-color($white);
    &:hover {
      background-color: darken($mint, 5%);
      border-color: $mint;
    }

    .hm-icon {
      display: block;
      width: 100% !important;
      max-width: 72px;
      height: auto!important;
    }

    .btn--inline__text {
      display: none!important;
    }

    &.btn--disabled {
      cursor: not-allowed!important;
      background-color: $middlegray!important;
      box-shadow: none!important;

      @include icon-color($white);
      .hm-icon {
        opacity: 0.6;
      }
    }
  }

  .btn--today {
    border-color: $mint;
  }
  @include custom-class('btn--no-margin') {
    margin: 0!important;
  }
  @include custom-class('btn--no-margin-top') {
    margin-top: 0!important;
  }
  @include custom-class('btn--no-margin-bottom') {
    margin-bottom: 0!important;
  }
  .btn--orange {
    // background-color: $orange;
    border-color: $orange;
    color: $orange;
    @include icon-color($orange);
    &:hover {
      background-color: rgba($orange, 0.15); //darken($mint, 2%);
      border-color: $orange;
    }
  }
  .btn--gray {
    background-color: $white;
    border-color: $gray;
    color: $gray;
    @include icon-color($gray);
    &:hover {
      background-color: rgba($gray, 0.15); //darken($mint, 2%);
      border-color: $gray;
    }
  }
  .btn--middlegray {
    background-color: $white;
    border-color: $middlegray;
    color: $middlegray;
    @include icon-color($middlegray);
    &:hover {
      background-color: rgba($middlegray, 0.15); //darken($mint, 2%);
      border-color: $middlegray;
    }
  }
  .btn--blue {
    background-color: $white;
    border-color: $blue;
    color: $blue;
    @include icon-color($blue);
    &:hover {
      background-color: rgba($blue, 0.15); //darken($mint, 2%);
      border-color: $blue;
    }
  }
  .btn--color {
    background-color: $white;
    border-color: rgba(var(--button-color), 1);
    color: rgba(var(--button-color), 1);
    @include icon-color(rgba(var(--button-color), 1));
    &:hover {
      background-color: rgba(var(--button-color), 0.15); //darken($mint, 2%);
      border-color: rgba(var(--button-color), 1);
    }
  }
  .btn--green {
    background-color: $white;
    border-color: $mint;
    color: $mint;
    @include icon-color($mint);
    &:hover {
      background-color: rgba($mint, 0.15); //darken($mint, 2%);
      border-color: $mint;
    }
  }
  .btn--red {
    background-color: $white;
    border-color: $red;
    color: $red;
    @include icon-color($red);
    &:hover {
      background-color: rgba($red, 0.1); //darken($mint, 2%);
      border-color: $red;
    }
  }
  .btn--password {
    background-color: $white;
    border-color: $orange;
    color: $black;
    transition: all 0.2s ease;
    .btn--inline__text {
      width: 100%;
      text-align: center;
      text-transform: uppercase;
    }
    margin: 1rem 0 0;
    @include icon-color($orange);
    &:hover {
      background-color: rgba($orange, 0.15); //darken($mint, 2%);
      border-color: $orange;
    }
  }
  .btn--login {
    direction: ltr;
    background-color: $orange;
    border-color: darken($orange, 2%);
    color: $black;
    transition: all 0.2s ease;
    .btn--inline__text {
      width: 100%;
      text-align: center;
      text-transform: uppercase;
    }
    margin: 1rem 0 0;
    @include icon-color($white);
    &:hover {
      background-color: darken($orange, 4%); //darken($mint, 2%);
      border-color: darken($orange, 6%);
    }
  }

</style>


<style lang="scss">
  @import '~styles/import';

  .btn--inline {
    @include icon-color($text);

    .hm-icon {
      display: inline-block;
      height: 3rem;
      width: 3rem;
      position: relative;
    }
    &:hover {
      cursor: pointer;
    }
  }

  .hm-table {
    .hm-table__td {
      .btn--inline {
        margin-top: 0.6rem;
        margin-bottom: 0.6rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/buttons/HmButton.vue